import { log } from '@shared/log.browser.ts';
import type { SelectionEvents } from '@tilelist/application/ports/SelectionEvents.ts';
import type { TrackingPort } from '@tilelist/application/ports/TrackingPort.ts';
import type { VariationLoader } from '@tilelist/application/ports/VariationLoader.ts';
import type { ProductItem, TileItem } from '@tilelist/domain/composition/TileListitem.ts';

export class ProductTileController {
    constructor(
        private readonly variationLoadingService: VariationLoader,
        private readonly trackingService: TrackingPort,
        private readonly selectionEvents: SelectionEvents,
    ) {}

    /**
 *
 *
 */
    async loadVariation(productItem: ProductItem, variationId: string): Promise<ProductItem> {
        const updated = await this.variationLoadingService.loadVariation(productItem, variationId);

        log.debug(`Tile loaded: ${productItem.localListPosition} (${variationId})`);
        return updated;
    }

    /**
 *
 */
    trackVisibility(item: TileItem): void {
        this.trackingService.trackTileVisibility(item);
    }

    /**
 *
 */
    trackClick(event: Event, productItem: ProductItem, rule: string): void {
        this.trackingService.trackClick(event, productItem, rule, this.selectionEvents.current().entryRule);
    }
}
